module.exports = __webpack_public_path__ + "img/chatting.6f0c9984.png";